import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const FEES_FEE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/fees',
        name: '::Menu:Fees',
        iconClass: 'fas fa-dollar-sign',
        layout: eLayoutType.application,
        requiredPolicy: 'ReturnLy.Fees',
        parentName: '::Menu:Configurations',
        order: 7,
      },
    ]);
  };
}
